import React, {
  useEffect,
  useState,
} from 'react';

import { useAppInfo } from 'AppState';
import Modal from 'components/Modal/Modal';
import useAddFinancials from 'data/user/financials/useAddFinancials';
import useUpdateOnboarding from 'data/user/onBoarding/useUpdateOnboarding';

import {
  Avatar,
  Button,
  Stack,
} from '@mui/material';

import { demoAccounts } from './data';

export default function DemoAccounts ({openModal}) {
    const {stateMyFinancials,stateApp,dispatchMyFinancials,dispatchPortfolio,dispatchHome} = useAppInfo()
    const {username,onboarding} = stateApp 
    const {financialView,demoProfile,demoProfileModal} = stateMyFinancials
    const {addFinancials} = useAddFinancials()
    const UpdateOnboarding = useUpdateOnboarding()
    const [demoProfileSelected,setDemoProfileSelected] = useState()
 
    useEffect(()=>{
      setDemoProfileSelected(demoProfile)
    },[demoProfile])


  const [mouseEnter,setMouseEnter] = useState(-1)   
  
  function handleOnboarding(){
    if (!onboarding?.financials){
    dispatchHome({clientSelected:demoProfileSelected})
    const updatedOnboarding = {...onboarding,financials:true,financialView:"demo",demoProfile:demoProfileSelected}
    UpdateOnboarding(username,updatedOnboarding);}
    else{
      dispatchHome({clientSelected:demoProfileSelected})
      const updatedOnboarding = {...onboarding,financialView:"demo",demoProfile:demoProfileSelected}
      UpdateOnboarding(username,updatedOnboarding); 
    }
  }
  function handleModal(){
   
    dispatchMyFinancials({demoProfileModal:false,financialView:"demo", 
      demoProfile: demoProfileSelected, financialsLoaded:false,financialsUpdated:false,assetUpdatedWithPortfolio:false})
    dispatchPortfolio({portfolioLoaded:false,portfolioResults:undefined})
    handleOnboarding() 
    // addFinancials(demoProfileSelected,"demoProfile")
  }
 
  function handleDemoProfile(v){
    setDemoProfileSelected(v)
  }

  return (
    <>
    {(demoProfileModal || openModal) &&
    <Modal sx={{background:"black",padding:"0.5rem"}} 
    width="80%" height="80%" onClose={()=>handleModal(false)}>
    <div style={{width:"100%",height:"100%",overflow:"auto",display:"flex",flexDirection:"column"
        ,gap:"1rem",alignItems:"center"}}>
    <div style={{padding:"2rem",borderRadius:"25px"}}>
    {/* <h1 style={{color:"white"}}>{`Hey ${username &&username?.split(" ")[0]},`}</h1> */}
    {/* <h1 style={{color:"white"}}>Get Started with Demo Account</h1><br/> */}
<h1 style={{color:"white"}}>Select one of the demo profiles below</h1>
{/* <h3 style={{color:"white"}}>When you're ready, connect your financials to unlock a fully personalized experience.</h3> */}
</div>
    <div
      style={{
        display: "flex",
        gap: "2rem",
        flexWrap: "wrap",
        justifyContent: "center",
        padding: "2rem"
      }}
    >
     
      {demoAccounts.map((account, index) => (
        <div
          key={index}
          onClick={() =>handleDemoProfile(account.name)}
          onMouseEnter={(e) => setMouseEnter(index)}
        onMouseLeave={(e) => setMouseEnter(-1)}
          style={{
            width: "100%",
            maxWidth: "450px",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            padding: "1.5rem",
            backgroundColor: "#fafafa",
            userSelect:"none",
            cursor:"pointer",
            boxSizing:"border-box",
            border:account.name === demoProfileSelected && "4px solid #1976d2",
            boxShadow:(mouseEnter === index && account.name !== demoProfileSelected) ? "0 8px 15px rgba(0, 0, 0, 0.2)" : account.name === demoProfileSelected && "0 2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Stack spacing={2} alignItems="center">
            <Avatar
              src={account?.img}
              sx={{
                bgcolor: "none",
                height: "100px",
                width: "100px",
                fontSize: "2.5rem",
              }}
            >
              {account.avatar}
            </Avatar>
            <div style={{ textAlign: "center" }}>
              <h2 style={{ margin: "0.5rem 0" }}>{account.name}</h2>
              <p style={{ color: "#757575", fontSize: "1rem", margin: "0.5rem 0" }}>
                {account.description}
              </p>
            </div>
          </Stack>

          <div style={{ padding: "1rem 0", display: "grid", gap: "1rem", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))" }}>
  {[
    { label: "Age", value: account.ageProfile, icon: "👤" },
    { label: "Family", value: account.familySituation, icon: "🏠" },
    { label: "Networth", value: account.networth, icon: "💰", progress: (account.networthNumber / 10000000) * 100 },
    // { label: "Assets", value: account.assets, icon: "📈", progress: (account.assets / account.networth) * 100 },
    // { label: "Liabilities", value: account.liabilities, icon: "📉", progress: (account.liabilities / account.networth) * 100 },
    { label: "Income", value: account.income, icon: "💵", progress: (account.incomeNumber / 500000) * 100 },
    // { label: "Expenses", value: account.expenses, icon: "💳", progress: (account.expenses / account.income) * 100 },
    { label: "Portfolio", value: account.portfolioDetails, icon: "📊" },
  ].map(({ label, value, icon, progress }) => (
    <div
      key={label}
      style={{
        padding: "0.5rem",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "0.5rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <span style={{ fontSize: "1.5rem" }}>{icon}</span>
        <strong>{label}:</strong>
        <div style={{ fontSize: "1rem", color: "#555" }}>{value}</div>
      </div>
      
      {progress !== undefined && (
        <div style={{ width: "100%", background: "#eee", borderRadius: "4px", overflow: "hidden" }}>
          <div
            style={{
              width: `${progress}%`,
              height: "8px",
              background: "#4caf50",
              transition: "width 0.3s ease",
            }}
          ></div>
        </div>
      )}
    </div>
  ))}
</div>
        </div>
      ))}
    </div>
    <div style={{position:"sticky",bottom:0,background:"black",width:"100%"}}>
      <div style={{padding:"1rem",textAlign:"center"}}>
        <Button variant="contained" onClick={()=>{handleModal(false)}}>Continue with Demo</Button>
      </div>
    </div>
    </div>
    </Modal>}
    </>
  );
};

// export function DemoProfileLogo(){
//   const {stateMyFinancials} = useAppInfo()
//   const {demoProfileSelected} = stateMyFinancials
//   return(
//     <>
//     <Avatar src={demoProfileSelected?.img}/>
//     </>
//   )
// }



export function DemoProfile({demoProfile="Emma Thompson"}){
  const {stateMyFinancials,dispatchMyFinancials} = useAppInfo();
  // const {demoProfile} = stateMyFinancials
  const demoProfileSelected = demoAccounts.filter(account => account.name === demoProfile)[0] || demoProfile
  return(
    <>
     <Avatar
            src={demoProfileSelected?.img}
            style={{
              cursor: "pointer",
              height: "30px",
              width: "30px",
              backgroundColor: "#gray",
              color: "black",
              fontSize: "0.8rem",
            }}
          >
            {demoProfileSelected && demoProfileSelected?.avatar}
          </Avatar>
    </>
  )
}

